import React, {useEffect, useRef, useState} from 'react';
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Input, InputGroup, InputGroupAddon, Label,
    Row
} from 'reactstrap';

import {
    error,
    FORM,
    saveMsg, selectOption, selectUdn,
    success,
    updateMsg
} from "../../../components/i18n/i18n";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit, GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {showToastCustom} from "../../../components/toast/customToast";
import {showLoader} from "../../../components/loader/loader";
import {useForm} from "react-hook-form";
import {udnProvider} from "../../../providers/udnProvider";
import {confMapsService} from "../../../jwt/_services/configuration/confMapsService";
import Select from "react-select";
import {SelectPlatformWithIcon} from "../../../components/select/selectPlatformWithIcon";
import {MapPickerModal} from "../../../components/map/MapPickerModal";
import {confirmAlert} from "react-confirm-alert";
import FirebaseTarget from "../../../components/firebaseTarget/firebaseTarget";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

let googleConfig = {};

export default function ConfMapsForm(props) {

    const [fbDataBaseId] = useState(props?.app?.fbDataBase?.id);
    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [disableInputs, setDisableInputs] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);
    const [loading, setLoading] = useState(false);
    const [udnOptions, setUdnOptions] = useState([]);
    const [udn, setUdn] = useState(editMode ? props.item?.udn : null);
    const [platform, setPlatform] = useState(editMode ? props.item?.platform : null);

    // Modal de posicion
    const positionPickerRef = useRef(null);
    const [showMap, setShowMap] = useState(false);
    const [positionToEdit, setPositionToEdit] = useState('B1')
    const [B1, setB1] = useState(editMode ? { lat: parseFloat(props.item?.bound1Lat), lng: parseFloat(props.item?.bound1Long) } :{ lat: 0.0, lng: 0.0 });
    const [B2, setB2] = useState(editMode ? { lat: parseFloat(props.item?.bound2Lat), lng: parseFloat(props.item?.bound2Long) } :{ lat: 0.0, lng: 0.0 });
    const [O1, setO1] = useState(editMode ? { lat: parseFloat(props.item?.overlay1Lat), lng: parseFloat(props.item?.overlay1Long) } :{ lat: 0.0, lng: 0.0 });
    const [O2, setO2] = useState(editMode ? { lat: parseFloat(props.item?.overlay2Lat), lng: parseFloat(props.item?.overlay2Long) } :{ lat: 0.0, lng: 0.0 });
    const [center, setCenter] = useState(editMode ? { lat: parseFloat(props.item?.latitude), lng: parseFloat(props.item?.longitude) } :{ lat: 0.0, lng: 0.0 });

    const [position, setPosition] = useState(editMode ? { lat: parseFloat(props.item?.latitude), lng: parseFloat(props.item?.longitude) } : {lat: 20.580, lng: -87.119});

    const [showModalHistory, setShowModalHistory] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModalHistory(true);
        modalRef.current.showModal(savedData);
    }

    // ----------------------------------------------
    //            ON LOAD
    // ----------------------------------------------
    useEffect(() => {
        setLoading(true);
        udnProvider.getOptions()
            .then(result => {
                if (result) {
                    setUdnOptions(result);
                    if (props.item?.udn) {
                        udnProvider.getItem(udn?.id)
                            .then(data => {
                                setUdn(data);
                                setLoading(false);
                            });
                    } else {
                        setLoading(false);
                    }
                }
                setLoading(false);
            })
            .catch(_ => {
                setLoading(false);

            })
    }, []);


    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            id: savedData?.id,
            uid: savedData?.uid,
            radiusLimit: savedData?.radiusLimit,
            defaultZoom: savedData?.defaultZoom,
            minZoom: savedData?.minZoom,
            maxZoom: savedData?.maxZoom,
            imgOverlay: savedData?.imgOverlay,

            latitude: savedData?.latitude,
            longitude: savedData?.longitude,

            bound1Lat: savedData?.bound1Lat,
            bound1Long: savedData?.bound1Long,
            bound2Lat: savedData?.bound2Lat,
            bound2Long: savedData?.bound2Long,

            overlay1Lat: savedData?.overlay1Lat,
            overlay1Long: savedData?.overlay1Long,
            overlay2Lat: savedData?.overlay2Lat,
            overlay2Long: savedData?.overlay2Long,

            style: savedData?.style
        }
    });

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    const onUdnChange = (value) => {
        setUdn(value);
    }

    const onPlatformChange = (value) => {
        setPlatform(value.value);
    }

    const onB1LatChange = (value) => { setB1({ lat: value, lng : B1.lng }) }

    const onB1LongChange = (value) => { setB1({  lat: B1.lat, lng : value }) }

    const onB2LatChange = (value) => { setB2({ lat: value, lng : B2.lng }) }

    const onB2LongChange = (value) => { setB2({  lat: B2.lat, lng : value }) }

    const onO1LatChange = (value) => { setO1({ lat: value, lng : O1.lng }) }

    const onO1LongChange = (value) => { setO1({  lat: O1.lat, lng : value }) }

    const onO2LatChange = (value) => { setO2({ lat: value, lng : O2.lng }) }

    const onO2LongChange = (value) => { setO2({  lat: O2.lat, lng : value }) }

    const onCenterLatChange = (value) => { setCenter({ lat: value, lng : center.lng }) }

    const onCenterLongChange = (value) => { setCenter({  lat: center.lat, lng : value }) }



    // ----------------------------------------------
    //            SUBMIT
    // ----------------------------------------------
    const confirmSubmit = (data) => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) =>
            <FirebaseTarget
                className={"mapConfig"}
                data={data}
                onSubmit={onSubmit}
                onClose={onClose}
            />
    });

    const onSubmit = (data, fbData, _) => {
        if (udn == null || platform == null) {
            setLoading(false);
            return showToastCustom(error, selectOption);
        }

        const dataRequest = {
            noDb : fbData.noDb,
            allDb : fbData.allDb,
            fbDataBase :  { id : fbData.fbDataBase?.id },
            item : {
                ...data,
                platform: platform,
                udn: { id : udn.id }
            },
        };
        if (!editMode) {
            //Save
            setLoading(true);
            return confMapsService.saveItem(dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    showToastCustom(success, saveMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        } else {
            //Update
            let id = savedData.id;
            dataRequest.mapConfig.id = id;

            setLoading(true);
            return confMapsService.updateItem(id, dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    showToastCustom(success, updateMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }
    };

    // ----------------------------------------------
    //            FORM BEHAVIOR
    // ----------------------------------------------
    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setDisableInputs(true);
        setSaveSuccess(true);
        setEditMode(true)
    }

    const resetForm = () => {
        setSavedData(null);
        setEditMode(false);
        setDisableInputs(false);
        setSaveSuccess(false);
        reset();
    }

    const beginEdit = () => {
        setEditMode(true);
        setSaveSuccess(false)
        setDisableInputs(false);
    }

    const setPositionModal = (positionP) => {
        switch (positionToEdit) {
            case 'B1':
                setB1(positionP);
                break;
            case 'B2':
                setB2(positionP);
                break;
            case 'O1':
                setO1(positionP);
                break;
            case 'O2':
                setO2(positionP);
                break;
            case 'C':
                setCenter(positionP);
                break;
        }
        setPosition(positionP);
    }

    const setCenterModal = (positionP) => {
        switch (positionP) {
            case 'B1':
                setPosition(B1);
                break;
            case 'B2':
                setPosition(B2);
                break;
            case 'O1':
                setPosition(O1);
                break;
            case 'O2':
                setPosition(O2);
                break;
            case 'C':
                setPosition(center);
                break;
        }
    }

    const showModal = (positionToEditP) => {
        if (udn == null ) {
            return showToastCustom(error, selectUdn);
        }
        //Get MapConfig for Udn
        if (udn != null) {
            setPositionToEdit(positionToEditP); // Indice de la posicion que se esta editando
            //setCenterModal(positionToEditP); // Indice de la posicion para el modal
            setLoading(true);
            let dataRequest = {
                fbDataBase : {  id : fbDataBaseId },
                item : {
                    platform: "ANDROID",
                    udn: {id: udn.id}
                }

            }
            confMapsService.search(0, 1000, dataRequest)
                .then(result => {
                    if (result?.data?.length > 0) {
                        let config = result?.data[0];
                        googleConfig = {
                            mapOptions: {
                                center: {
                                    lat: parseFloat(position?.lat),
                                    lng: parseFloat(position?.lng)
                                },
                                disableDefaultUI: false,
                                mapTypeControl: false,
                                rotateControl: false,
                                streetViewControl: false,
                                zoom: config.defaultZoom,
                                minZoom: config.minZoom,
                                maxZoom: config.maxZoom
                            },
                            overlay: {
                                udn: config.udnCode.toLowerCase(),
                                pto1: {
                                    lat: config.overlay1Lat,
                                    lng: config.overlay1Long
                                },
                                pto2: {
                                    lat: parseFloat(config.overlay2Lat),
                                    lng: parseFloat(config.overlay2Long)
                                }
                            },
                            bound: {
                                sw: {
                                    lat: parseFloat(config.bound2Lat),
                                    lng: parseFloat(config.bound2Long)
                                },
                                ne: {
                                    lat: parseFloat(config.bound1Lat),
                                    lng: parseFloat(config.bound1Long)
                                }
                            },
                            marker: {
                                title: savedData?.uid,
                                name: savedData?.uid
                            }
                        }
                        setShowMap(true);
                        positionPickerRef.current.showModal();
                    }
                    setLoading(false);
                })
                .catch(_ => {
                    setLoading(false);
                })
        }
    }

    const setForm = () => {
        props.setForm(null, null, "LIST");
    }

    return (
        <Card>
            {loading ? showLoader() : null}
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(confirmSubmit)}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="UdnId">Id</Label>
                                <Input type="id" name="id" id="id"
                                       disabled
                                       value={editMode ? savedData?.id : ''}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="uidUdn">UID Firebase</Label>
                                <Input type="id" name="uid" id="uid"
                                       disabled
                                       value={editMode ? savedData?.uid : ''}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>Unidad de negocio</Label>
                                <br/>
                                <Select
                                    value={udn}
                                    options={udnOptions}
                                    onChange={onUdnChange}
                                    isDisabled={disableInputs}
                                    innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>Plataforma</Label>
                                <br/>
                                <SelectPlatformWithIcon name="platform"
                                                        innerRef={register}
                                                        ref={register}
                                                        value={platform}
                                                        disabled={disableInputs}
                                                        onChange={onPlatformChange}/>
                            </FormGroup>

                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>CENTRO [lat,lng]</Label>
                                <InputGroup>
                                    <Input type="number" name="latitude" id="latitude"
                                           // value={center?.lat }
                                           step="0.00001"
                                           className={"remove-flex"}
                                           innerRef={register}
                                           disabled={disableInputs}
                                           onChange={e => onCenterLatChange(e.target.value)}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <Input type="number" name="longitude" id="longitude"
                                               // value={ center?.lng}
                                               step="0.00001"
                                               className={"remove-flex"}
                                               innerRef={register}
                                               disabled={disableInputs}
                                               onChange={e => onCenterLongChange(e.target.value)}
                                        />
                                        {/*<Button color=" background-color-primary" onClick={() => showModal('C')} disabled={disableInputs}>*/}
                                        {/*    <i className="fas fa-map-marker-alt text-white"/>*/}
                                        {/*</Button>*/}
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label htmlFor="imgOverlay">Overlay</Label>
                                <Input type="name" name="imgOverlay" id="imgOverlay"
                                       placeholder="Nombre imagen"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>BOUND 1 [lat,lng]</Label>
                                <InputGroup>
                                    <Input type="number" name="bound1Lat" id="bound1Lat"
                                        // value={B1?.lat }
                                           step="0.00001"
                                           className={"remove-flex"}
                                           innerRef={register}
                                           disabled={disableInputs}
                                           onChange={e => onB1LatChange(e.target.value)}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <Input type="number" name="bound1Long" id="bound1Long"
                                            // value={ B1?.lng}
                                               step="0.00001"
                                               className={"remove-flex"}
                                               innerRef={register}
                                               disabled={disableInputs}
                                               onChange={e => onB1LongChange(e.target.value)}
                                        />
                                        {/*<Button color=" background-color-primary" onClick={() => showModal('B1')} disabled={disableInputs}>*/}
                                        {/*    <i className="fas fa-map-marker-alt text-white"/>*/}
                                        {/*</Button>*/}
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>OVERLAY 1 [lat,lng]</Label>
                                <InputGroup>
                                    <Input type="number" name="overlay1Lat" id="overlay1Lat"
                                        // value={O1?.lat }
                                           step="0.00001"
                                           className={"remove-flex"}
                                           innerRef={register}
                                           disabled={disableInputs}
                                           onChange={e => onO1LatChange(e.target.value)}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <Input type="number" name="overlay1Long" id="overlay1Long"
                                            // value={ O1?.lng}
                                               step="0.00001"
                                               className={"remove-flex"}
                                               innerRef={register}
                                               disabled={disableInputs}
                                               onChange={e => onO1LongChange(e.target.value)}
                                        />
                                        {/*<Button color=" background-color-primary" onClick={() => showModal('O1')} disabled={disableInputs}>*/}
                                        {/*    <i className="fas fa-map-marker-alt text-white"/>*/}
                                        {/*</Button>*/}
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>BOUND 2 [lat,lng]</Label>
                                <InputGroup>
                                    <Input type="number" name="bound2Lat" id="bound2Lat"
                                        // value={B2?.lat }
                                           step="0.00001"
                                           className={"remove-flex"}
                                           innerRef={register}
                                           disabled={disableInputs}
                                           onChange={e => onB2LatChange(e.target.value)}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <Input type="number" name="bound2Long" id="bound2Long"
                                            // value={ B2?.lng}
                                               step="0.00001"
                                               className={"remove-flex"}
                                               innerRef={register}
                                               disabled={disableInputs}
                                               onChange={e => onB2LongChange(e.target.value)}
                                        />
                                        {/*<Button color=" background-color-primary" onClick={() => showModal('B2')} disabled={disableInputs}>*/}
                                        {/*    <i className="fas fa-map-marker-alt text-white"/>*/}
                                        {/*</Button>*/}
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>OVERLAY 2 [lat,lng]</Label>
                                <InputGroup>
                                    <Input type="number" name="overlay2Lat" id="overlay2Lat"
                                        // value={O2?.lat }
                                           step="0.00001"
                                           className={"remove-flex"}
                                           innerRef={register}
                                           disabled={disableInputs}
                                           onChange={e => onO2LatChange(e.target.value)}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <Input type="number" name="overlay2Long" id="overlay2Long"
                                               // value={ O2?.lng}
                                               step="0.00001"
                                               className={"remove-flex"}
                                               innerRef={register}
                                               disabled={disableInputs}
                                               onChange={e => onO2LongChange(e.target.value)}
                                        />
                                        {/*<Button color=" background-color-primary" onClick={() => showModal('O2')} disabled={disableInputs}>*/}
                                        {/*    <i className="fas fa-map-marker-alt text-white"/>*/}
                                        {/*</Button>*/}
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="defaultZoom">Zoom Defecto</Label>
                                <Input type="number" name="defaultZoom" id="defaultZoom"
                                       placeholder="Zoom Defecto"
                                       innerRef={register}
                                       disabled={disableInputs}/>
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="minZoom">Zoom Mínimo</Label>
                                <Input type="number" name="minZoom" id="minZoom"
                                       placeholder="Zoom Mínimo"
                                       innerRef={register}
                                       disabled={disableInputs}/>
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="maxZoom">Zoom Máximo</Label>
                                <Input type="number" name="maxZoom" id="maxZoom"
                                       placeholder="Zoom Máximo"
                                       innerRef={register}
                                       disabled={disableInputs}/>
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="radiusLimit">Radio Límite</Label>
                                <Input type="number" name="radiusLimit" id="radiusLimit"
                                       step="any"
                                       placeholder="Radio Límite"
                                       innerRef={register}
                                       disabled={disableInputs}/>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label>Style</Label>
                                <Input type="textarea" rows="3" name="style" id="style"
                                       placeholder="Estilo del mapa"
                                       disabled={disableInputs}
                                       innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={() => {
                                        resetForm()
                                    }}/>
                                    <ButtonEdit onClick={() => {
                                        beginEdit()
                                    }}/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
            {
                showMap &&
                <MapPickerModal
                    ref={positionPickerRef}
                    setPosition={setPositionModal}
                    initialPosition={position}
                    googleConfig={googleConfig}
                    updateMarkerPosition={true}/>
            }

            {
                showModalHistory && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </Card>
    )
}